var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_vm._l((_vm.menu),function(box,index){return _c('div',{key:index,staticClass:"box"})}),_c('div',{class:{ fixMenu: _vm.fixed, unFixMenu: !_vm.fixed }}),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }